import { MapPinHouseIcon } from 'lucide-react';
import { useCallback, useEffect, useRef, useState } from "react";
import { IoCaretBackOutline } from "react-icons/io5";
import { MdOutlineAddLocationAlt } from "react-icons/md";
import { useDispatch } from "react-redux";
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, convertToNumber, deleteData, sanitizeInput } from '../CommonComponents/CustomHooks';
import { CommonApiData,initializeFilterData } from '../CommonComponents/EnvConfig';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, AutoCompleteBoxNumeric, FormButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const PickupPointMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [showForm, setShowForm] = useState(false);
    const [mapCoords, setMapCoords] = useState({ lat: null, lng: null });
    const [polygonCoords, setPolygonCoords] = useState([]);
    const mapRef = useRef(null);
    const googleMapRef = useRef(null);
    const markerRef = useRef(null);
    const drawingManagerRef = useRef(null);
    const currentPolygonRef = useRef(null);
    //const loginUserClientCode = CommonApiData().loginUserClientCode;
    const initialFormData = {
        pickupID: '',
        pickupPointName: '',
        //client: loginUserClientCode,
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        mobileNo: '',
        driver: '',
        city: '',
        state: '',
        country: '',
        pincode: '',
        active: true,
        isRiskPoint: false,
        isAlertRadius: false,
        latitude: '',
        longitude: '',
        polygon: '',
        pointType: 'Both',
        radius: '',
        addressCategory: '1',
    }
    const [formData, setFormData] = useState(initialFormData);
    const GetPointType = DropDownData('GetPointType')
    const GetCategoryType = DropDownData('GetAddressCategoryType')
    const getPickupPointMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Shipment/ShowPickupPointMaster`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res)
        }
        if (res.Status === 'ERROR') {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData(initialFormData);
        filterData.SearchText = '';
        setMapCoords({ lat: null, lng: null });
        setPolygonCoords([]);
        if (markerRef.current) {
            markerRef.current.setMap(null);
            markerRef.current = null;
        }
        if (currentPolygonRef.current) {
            currentPolygonRef.current.setMap(null);
            currentPolygonRef.current = null;
        }
        const mapSearchInput = document.getElementById("mapSearchInput");
        if (mapSearchInput) {
            mapSearchInput.value = "";
        }
        getPickupPointMasterData();
    }
    const handleBackButtonClick = () => {
        setShowForm(false);
        setFormData(initialFormData);
        setMapCoords({ lat: null, lng: null });
        setPolygonCoords([]);

    }

    const handleSubmit = async () => {
        const updatedFormData = {
            ...formData,
            latitude: mapCoords.lat
                ? String(parseFloat(mapCoords.lat).toFixed(6))
                : '',
            longitude: mapCoords.lng
                ? String(parseFloat(mapCoords.lng).toFixed(6))
                : '',
            polygon: polygonCoords.length > 0
                ? polygonCoords.map(c => ({
                    latitude: String(parseFloat(c.lat).toFixed(6)),
                    longitude: String(parseFloat(c.lng).toFixed(6))
                }))
                : [],
        };
        setFormData(updatedFormData);
        await dispatch(setSubLoading(true));
        let data = await ApiCall(
            `/api/Shipment/InsertUpdatePickupPointMaster`,
            updatedFormData
        );
        await dispatch(setSubLoading(false));
        if (data.status === 'SUCCESS') {
            // Auto-redirect to list after successful save
            setShowForm(false);
            setFormData(initialFormData);
            setMapCoords({ lat: null, lng: null });
            setPolygonCoords([]);
            getPickupPointMasterData();
        }
        await NotificationSound(
            data.status,
            data.message,
            data.focus,
            inputrefs
        );
    };

    //const handleEditData = async (id) => {
    //    await dispatch(setSubLoading(true))
    //    let editData = await ApiCall(`/api/Master/EditPickupPointMaster`, { pickupID: id })
    //    await dispatch(setSubLoading(false))
    //    if (editData.status === 'SUCCESS') {
    //        let record = editData
    //        setFormData((pre) => ({
    //            ...pre, ...record
    //        }))
    //        await inputrefs.current[editData.focus].focus();
    //    }
    //    else {
    //        await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
    //    }
    //}

    const handleEditData = async (id) => {
        debugger
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Shipment/EditPickupPointMaster`, { pickupID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            setShowForm(true);
            let polygon = (editData.polygon || [])
                .filter(p => p.latitude !== '' && p.longitude !== '' &&
                    !isNaN(parseFloat(p.latitude)) && !isNaN(parseFloat(p.longitude)))
                .map(p => ({
                    lat: parseFloat(p.latitude),
                    lng: parseFloat(p.longitude)
                }));

            setFormData((pre) => ({
                ...pre,
                ...editData,
                polygon: polygon,
                latitude: editData.latitude,
                longitude: editData.longitude,
            }));

            setPolygonCoords(polygon);
            if (editData.latitude && editData.longitude) {
                setMapCoords({
                    lat: parseFloat(editData.latitude),
                    lng: parseFloat(editData.longitude)
                });
            } else {
                setMapCoords({ lat: null, lng: null });
            }
            //await inputrefs.current[editData.focus].focus();
        } else {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
    };
    const GetCityStateByPincode = async (pincode) => {
        await dispatch(setSubLoading(true));
        let data = await ApiCall(`/api/Dashboard/GetPinCodeByCityState`, { pincode: pincode || "" });
        await dispatch(setSubLoading(false));
        if (data?.status === 'SUCCESS') {
            setFormData(prev => ({
                ...prev,
                city: data?.city || "",
                state: data?.state || "",
                pincode: pincode || "",
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                city: "",
                state: "",
                pincode: pincode || "",
            }));
        }
    };

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Shipment/DeletePickupPointMaster`, { pickupID: id }, getPickupPointMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        getPickupPointMasterData(value);
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    useEffect(() => {
        // inputrefs.current['txtPickupPointName'].focus()
        document.title = 'Address Book'
        getPickupPointMasterData()
    }, [sortConfig]);


    //--Map Modal--//
    const initMap = useCallback((initialPolygon = [], initialMarker = { lat: null, lng: null }, initialRadius = '') => {
        if (!mapRef.current || !window.google) return;

        const defaultCenter = { lat: 28.50284248045983, lng: 77.41158187754507 };
        const map = new window.google.maps.Map(mapRef.current, {
            center: defaultCenter,
            zoom: 14,
            mapTypeControl: true,
            streetViewControl: false,
        });
        googleMapRef.current = map;

        const input = document.getElementById("mapSearchInput");
        if (input) {
            const autocomplete = new window.google.maps.places.Autocomplete(input);
            autocomplete.bindTo("bounds", map);
            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                if (!place.geometry || !place.geometry.location) return;
                const location = place.geometry.location;
                map.setCenter(location);
                map.setZoom(16);
                placeMarker(location, map, true);
                if (currentPolygonRef.current) currentPolygonRef.current.setMap(null);
            });
        }

        if (formData.addressLine1 && !initialMarker?.lat && initialPolygon.length === 0) {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: formData.addressLine1 }, (results, status) => {
                if (status === 'OK') {
                    const loc = results[0].geometry.location;
                    map.setCenter(loc);
                    map.setZoom(16);
                }
            });
        }

        map.addListener('click', (e) => {
            placeMarker(e.latLng, map, true);
            if (currentPolygonRef.current) currentPolygonRef.current.setMap(null);
        });

        const drawingManager = new window.google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            polygonOptions: {
                fillColor: '#185FA5',
                fillOpacity: 0.2,
                strokeWeight: 2,
                strokeColor: '#185FA5',
                editable: true,
            },
            circleOptions: {
                fillColor: '#185FA5',
                fillOpacity: 0.2,
                strokeWeight: 2,
                strokeColor: '#185FA5',
                editable: true,
                zIndex: 1
            }
        });
        drawingManager.setMap(map);
        drawingManagerRef.current = drawingManager;
        window.google.maps.event.addListener(drawingManager, 'polygoncomplete', (polygon) => {
            if (currentPolygonRef.current) currentPolygonRef.current.setMap(null);
            currentPolygonRef.current = polygon;
            drawingManager.setDrawingMode(null);
            extractPolygonCoords(polygon);
            ['set_at', 'insert_at', 'remove_at'].forEach(event => {
                polygon.getPath().addListener(event, () => extractPolygonCoords(polygon));
            });
            //if (markerRef.current) markerRef.current.setMap(null);
            //setMapCoords({ lat: null, lng: null });
        });

        window.google.maps.event.addListener(drawingManager, 'circlecomplete', (circle) => {
            if (currentPolygonRef.current) currentPolygonRef.current.setMap(null);
            currentPolygonRef.current = circle;
            drawingManager.setDrawingMode(null);

            const extractCircleCoords = () => {
                const center = circle.getCenter();
                const radius = circle.getRadius();
                setPolygonCoords([]);
                setFormData(prev => ({
                    ...prev,
                    radius: Math.round(radius).toString()
                }));
                if (!markerRef.current) {
                    markerRef.current = new window.google.maps.Marker({ position: center, map: googleMapRef.current });
                    setMapCoords({ lat: center.lat().toString(), lng: center.lng().toString() });
                }
            };

            extractCircleCoords();

            ['radius_changed', 'center_changed'].forEach(event => {
                window.google.maps.event.addListener(circle, event, extractCircleCoords);
            });
        });

        if (initialMarker?.lat && initialMarker?.lng) {
            const location = { lat: Number(initialMarker.lat), lng: Number(initialMarker.lng) };

            placeMarker(location, map, false, false);

            if (initialRadius && initialPolygon.length === 0) {
                const circle = new window.google.maps.Circle({
                    strokeColor: '#185FA5',
                    strokeWeight: 2,
                    fillColor: '#185FA5',
                    fillOpacity: 0.2,
                    map: map,
                    center: location,
                    radius: Number(initialRadius),
                    editable: true
                });
                currentPolygonRef.current = circle;

                const extractCircleCoords = () => {
                    const center = circle.getCenter();
                    const radius = circle.getRadius();

                    setFormData(prev => ({
                        ...prev,
                        radius: Math.round(radius).toString()
                    }));

                    if (!markerRef.current) {
                        markerRef.current = new window.google.maps.Marker({ position: center, map: map });
                        setMapCoords({ lat: center.lat().toString(), lng: center.lng().toString() });
                    }
                };

                ['radius_changed', 'center_changed'].forEach(event => {
                    window.google.maps.event.addListener(circle, event, extractCircleCoords);
                });

                const bounds = circle.getBounds();
                if (bounds) {
                    map.fitBounds(bounds);
                } else {
                    map.setCenter(location);
                    map.setZoom(16);
                }
            } else {
                map.setCenter(location);
                map.setZoom(16);
            }
        }
        if (initialPolygon.length > 0) {
            const polygon = new window.google.maps.Polygon({
                paths: initialPolygon,
                fillColor: '#185FA5',
                fillOpacity: 0.2,
                strokeWeight: 2,
                strokeColor: '#185FA5',
                editable: true,
                map: map
            });
            currentPolygonRef.current = polygon;
            ['set_at', 'insert_at', 'remove_at'].forEach(event => {
                polygon.getPath().addListener(event, () => extractPolygonCoords(polygon));
            });
            const bounds = new window.google.maps.LatLngBounds();
            initialPolygon.forEach(coord => bounds.extend(coord));
            map.fitBounds(bounds);
            // Ensure a marker exists at the center if not loaded
            if (!markerRef.current) {
                const lats = initialPolygon.map(c => c.lat);
                const lngs = initialPolygon.map(c => c.lng);
                const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2;
                const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2;
                const center = { lat: centerLat, lng: centerLng };
                markerRef.current = new window.google.maps.Marker({ position: center, map: map });
                setMapCoords({ lat: centerLat.toString(), lng: centerLng.toString() });
            }
        }
    }, [formData.addressLine1]);

    const placeMarker = (location, map, clearPolygon = false, doGeocode = true) => {
        if (markerRef.current) markerRef.current.setMap(null);
        const marker = new window.google.maps.Marker({ position: location, map });
        markerRef.current = marker;
        const lat = typeof location.lat === "function" ? location.lat() : location.lat;
        const lng = typeof location.lng === "function" ? location.lng() : location.lng;
        setMapCoords({ lat: lat.toString(), lng: lng.toString() });
        if (doGeocode) {
            getAddressFromLatLng(lat, lng);
        }
        if (clearPolygon) {
            setPolygonCoords([]);
            setFormData(prev => ({ ...prev, radius: '' }));
        }
    };
    const getAddressFromLatLng = async (lat, lng) => {
        if (!window.google || !googleMapRef.current) return;
        const geocoder = new window.google.maps.Geocoder();
        const location = new window.google.maps.LatLng(lat, lng);
        const SearchLocationInput = document.getElementById("mapSearchInput");
        geocoder.geocode(
            {
                location
            },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    let address = results[0].formatted_address;
                    SearchLocationInput.value = address
                    let city = "";
                    let state = "";
                    let country = "";
                    let pincode = "";
                    results[0].address_components.forEach(component => {
                        const types = component.types;
                        if (types.includes("locality")) {
                            city = component.long_name;
                        }
                        if (types.includes("administrative_area_level_1")) {
                            state = component.long_name;
                        }
                        if (types.includes("country")) {
                            country = component.long_name;
                        }
                        if (types.includes("postal_code")) {
                            pincode = component.long_name;
                        }
                    });
                    const service =
                        new window.google.maps.places.PlacesService(
                            googleMapRef.current
                        );
                    service.nearbySearch(
                        {
                            location,
                            radius: 100,
                        },
                        (places, placeStatus) => {

                            let pickupName = "";

                            if (
                                placeStatus ===
                                window.google.maps.places.PlacesServiceStatus.OK &&
                                places &&
                                places.length > 0
                            ) {
                                pickupName = places[0].name;
                            } else {
                                pickupName = city || "Address Book";
                            }
                            setFormData(prev => ({
                                ...prev,
                                pickupPointName: pickupName,
                                addressLine1: address,
                                city,
                                state,
                                country,
                                pincode
                            }));
                        }
                    );
                }
            }
        );
    };
    const extractPolygonCoords = (polygon) => {
        const path = polygon.getPath().getArray();
        const coords = path.map(p => ({ lat: p.lat(), lng: p.lng() }));
        setPolygonCoords(coords);

        if (coords.length > 0) {
            const lats = coords.map(c => c.lat);
            const lngs = coords.map(c => c.lng);
            const minLat = Math.min(...lats), maxLat = Math.max(...lats);
            const minLng = Math.min(...lngs), maxLng = Math.max(...lngs);
            const centerLat = (minLat + maxLat) / 2;
            const centerLng = (minLng + maxLng) / 2;
            const center = new window.google.maps.LatLng(centerLat, centerLng);
            if (!markerRef.current) {
                markerRef.current = new window.google.maps.Marker({ position: center, map: googleMapRef.current });
                setMapCoords({ lat: centerLat.toString(), lng: centerLng.toString() });
            }
            // Haversine distance from center to corner
            const R = 6371000; // Earth radius in metres
            const dLat = (maxLat - centerLat) * Math.PI / 180;
            const dLng = (maxLng - centerLng) * Math.PI / 180;
            const a = Math.sin(dLat / 2) ** 2 +
                Math.cos(centerLat * Math.PI / 180) * Math.cos(maxLat * Math.PI / 180) *
                Math.sin(dLng / 2) ** 2;
            const approxRadius = Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
            setFormData(prev => ({ ...prev, radius: approxRadius.toString() }));
        }
    };

    useEffect(() => {
        if (!showForm) return;
        const timer = setTimeout(() => {
            if (mapRef.current && window.google) {
                initMap(polygonCoords, mapCoords, formData.radius);
                setTimeout(() => {
                    if (googleMapRef.current) {
                        window.google.maps.event.trigger(
                            googleMapRef.current,
                            "resize"
                        );
                    }
                }, 100);
            }
        }, 300);

        return () => {
            clearTimeout(timer);
            if (markerRef.current) {
                markerRef.current.setMap(null);
                markerRef.current = null;
            }
            if (currentPolygonRef.current) {
                currentPolygonRef.current.setMap(null);
                currentPolygonRef.current = null;
            }
            googleMapRef.current = null;
        };
    }, [showForm]);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3 '>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center justify-between w-100">
                        <div className="flex items-center gap-2">
                            <MapPinHouseIcon className="w-5 h-5 text-primary-600" />
                            <h2 className="text-xl font-semibold text-primary-600">Address Book</h2>
                        </div>
                        <div className='items-center'>
                            {!showForm ?
                                <button
                                    type="button"
                                    onClick={() => setShowForm(true)}
                                    className="flex items-center gap-2 ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-[12px] hover:shadow-lg duration-300 ease-in-out"                                >

                                    <span><MdOutlineAddLocationAlt /></span>
                                    <span>Add New Address</span>
                                </button>
                                :
                                <button
                                    type="button"
                                    onClick={handleBackButtonClick}
                                    className=" flex items-center gap-2 ripple-btn px-4 py-2 bg-black text-white rounded font-medium shadow-md uppercase tracking-wide text-[12px] transition-all hover:shadow-lg duration-300 ease-in-out" >
                                    <span><IoCaretBackOutline /></span>
                                    <span>Back</span>

                                </button>
                            }
                        </div>
                    </div>
                </div>
                {showForm && (
                    <div className='w-100 flex gap-2 pickup-point-layout'>
                        <div className='card-body pb-1 xs:w-100 sm:w-100 ' style={{ flex: 5 }}>
                            <div className='grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-3'>

                                <InputBox
                                    id="txtPickupPointName"
                                    required
                                    label="Location Name"
                                    placeholder="Enter Location Name"
                                    inputrefs={inputrefs}
                                    value={formData.pickupPointName || ''}
                                    maxLength='50'
                                    onChange={(e) => setFormData({ ...formData, pickupPointName: sanitizeInput(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtAddressLine1"].focus();
                                    }}
                                />

                                <div className="relative">
                                    <InputBox
                                        id="txtAddressLine1"
                                        label="Address Line 1"
                                        required
                                        placeholder="Enter Address Line 1"
                                        inputrefs={inputrefs}
                                        maxLength='250'
                                        value={formData.addressLine1 || ''}
                                        onChange={(e) => setFormData({ ...formData, addressLine1: sanitizeInput(e.target.value) })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') inputrefs.current["txtAddressLine2"].focus();
                                        }}
                                    />
                                </div>

                                <InputBox
                                    id="txtAddressLine2"
                                    label="Address Line 2"
                                    placeholder="Enter Address Line 2"
                                    maxLength='250'
                                    inputrefs={inputrefs}
                                    value={formData.addressLine2 || ''}
                                    onChange={(e) => setFormData({ ...formData, addressLine2: sanitizeInput(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtAddressLine3"].focus();
                                    }}
                                />

                                <InputBox
                                    id="txtAddressLine3"
                                    label="Address Line 3"
                                    placeholder="Enter Address Line 3"
                                    maxLength='250'
                                    inputrefs={inputrefs}
                                    value={formData.addressLine3 || ''}
                                    onChange={(e) => setFormData({ ...formData, addressLine3: sanitizeInput(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtDriver"].focus();
                                    }}
                                />

                                {/*<InputBox*/}
                                {/*    id="txtMobileNo"*/}
                                {/*    label="Mobile No"*/}
                                {/*    required*/}
                                {/*    maxLength="10"*/}
                                {/*    placeholder="Enter Mobile No"*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    value={formData.mobileNo || ''}*/}
                                {/*    onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') inputrefs.current["txtDriver"].focus();*/}
                                {/*    }}*/}
                                {/*/>*/}

                                <InputBox
                                    id="txtDriver"
                                    label="Driver Name"
                                    placeholder="Enter Driver Name"
                                    inputrefs={inputrefs}
                                    maxLength='50'
                                    value={formData.driver || ''}
                                    onChange={(e) => setFormData({ ...formData, driver: sanitizeInput(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtPinCode"].focus();
                                    }}
                                />
                                <AutoCompleteBoxNumeric
                                    id="txtPinCode"
                                    label="Pincode"
                                    placeholder="Enter Pincode"
                                    autocompleteType="GetPinCode"
                                    value={formData.pincode || ""}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            const updatedData = { ...formData, pincode: newInputValue };
                                            setFormData(updatedData);
                                            GetCityStateByPincode(newInputValue);
                                        }
                                    }}
                                    required

                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            inputrefs.current['txtCity'].focus()
                                        }
                                    }}
                                    maxLength='6'
                                />

                                <AutoCompleteBoxNew
                                    id="txtCity"
                                    label="City"
                                    required
                                    placeholder="Select City"
                                    inputrefs={inputrefs}
                                    autocompleteType="GetCity"
                                    value={formData.city || ''}

                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, city: newInputValue })
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtState"].focus();
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    id="txtState"
                                    label="State"
                                    required
                                    placeholder="Select State"
                                    inputrefs={inputrefs}
                                    autocompleteType="GetState"
                                    value={formData.state || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, state: newInputValue })
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtPointType"].focus();
                                    }}
                                />

                                <SelectInputBox
                                    id="txtPointType"
                                    label="Point Type"
                                    required
                                    value={formData.pointType}
                                    onChange={(e) =>
                                        setFormData({ ...formData, pointType: e.target.value, destinationValue: '' })
                                    }
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => e.key === 'Enter' && inputrefs.current['txtRadius'].focus()}
                                >
                                    {GetPointType?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>

                                <InputBox
                                    id="txtRadius"
                                    label="Radius"
                                    placeholder="Enter Radius"
                                    inputrefs={inputrefs}
                                    maxLength='50'
                                    value={formData.radius || ''}
                                    onChange={(e) => setFormData({ ...formData, radius: convertToNumber(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') inputrefs.current["txtCategory"].focus();
                                    }}
                                />

                                <SelectInputBox
                                    id="txtCategory"
                                    label="Address Category"
                                    required
                                    value={formData.addressCategory}
                                    onChange={(e) =>
                                        setFormData({ ...formData, addressCategory: e.target.value, destinationValue: '' })
                                    }
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => e.key === 'Enter' && inputrefs.current['txtRiskPoint'].focus()}
                                >
                                    {GetCategoryType?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>

                                <Switch
                                    label='Risk Point'
                                    checked={formData.isRiskPoint}
                                    id='txtRiskPoint'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAlertRadius'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isRiskPoint: e.target.checked })}
                                    divclassname="mt-2 inline-flex"
                                />
                                <Switch
                                    label='Alert Radius'
                                    checked={formData.isAlertRadius}
                                    id='txtAlertRadius'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isAlertRadius: e.target.checked })}
                                    divclassname="mt-2 inline-flex"
                                />
                                <Switch
                                    label='Active'
                                    checked={formData.active}
                                    id='txtActive'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                    divclassname="mt-2 inline-flex"
                                />
                            </div>
                            <div className='card-body'>
                                <FormButton
                                    id={'btnSub'}
                                    inputrefs={inputrefs}
                                    handleSubmit={handleSubmit}
                                    handleExport={async () => {
                                        await dispatch(setSubLoading(true))
                                        await handleDownloadExcel(`/api/Shipment/ShowPickupPointMaster`, filterData, 'Address Book')
                                        await dispatch(setSubLoading(false))
                                    }}
                                    handleClear={handleClear}
                                />
                            </div>
                        </div>
                        <div style={{ flex: 7 }}>
                            <div className="bg-white rounded-xl w-full max-w-full overflow-hidden">
                                {/* Header */}
                                <div className="py-3 px-4 border-b">
                                    <div className="flex items-center gap-2 mb-2">
                                        <MapPinHouseIcon className="w-5 h-5 text-primary-600" />
                                        <span className="font-semibold text-primary-600">Select Location</span>
                                        {formData.city && (
                                            <span className="text-xs text-gray-500">— {formData.city}</span>
                                        )}
                                    </div>
                                    {/* Place-name search */}
                                    <input
                                        id="mapSearchInput"
                                        type="text"
                                        placeholder="Search location by name..."
                                        className="border rounded p-2 text-sm w-full outline-none focus:border-primary-500 transition-colors mb-2"
                                    />
                                    {/* Lat / Lng search */}
                                    <div className="flex items-center gap-2">
                                        <input
                                            id="latInput"
                                            type="number"
                                            step="any"
                                            placeholder="Latitude"
                                            className="border rounded p-2 text-sm flex-1 outline-none focus:border-primary-500 transition-colors"
                                        />
                                        <input
                                            id="lngInput"
                                            type="number"
                                            step="any"
                                            placeholder="Longitude"
                                            className="border rounded p-2 text-sm flex-1 outline-none focus:border-primary-500 transition-colors"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const lat = parseFloat(document.getElementById('latInput').value);
                                                const lng = parseFloat(document.getElementById('lngInput').value);
                                                if (isNaN(lat) || isNaN(lng)) {
                                                    alert('Please enter valid Latitude and Longitude values.');
                                                    return;
                                                }
                                                if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
                                                    alert('Latitude must be between -90 and 90, Longitude between -180 and 180.');
                                                    return;
                                                }
                                                const location = { lat, lng };
                                                if (googleMapRef.current) {
                                                    googleMapRef.current.setCenter(location);
                                                    googleMapRef.current.setZoom(16);
                                                    if (currentPolygonRef.current) {
                                                        currentPolygonRef.current.setMap(null);
                                                        currentPolygonRef.current = null;
                                                    }
                                                    placeMarker(location, googleMapRef.current, true);
                                                }
                                            }}
                                            className="px-3 py-2 text-sm bg-[var(--theme-color)] text-white rounded hover:opacity-90 whitespace-nowrap"
                                        >
                                            📍 Go
                                        </button>
                                    </div>
                                </div>
                                {/* Map */}
                                <div
                                    ref={mapRef}
                                    style={{ height: '650px', width: '100%' }}
                                />
                                <div className="px-4 py-3 border-t space-y-3">
                                    <div className="flex gap-2">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (drawingManagerRef.current)
                                                    drawingManagerRef.current.setDrawingMode(
                                                        window.google.maps.drawing.OverlayType.POLYGON
                                                    );
                                            }}
                                            className="flex-1 py-2 text-sm border rounded-lg hover:bg-white"
                                        >
                                            🔷 Draw Polygon Area
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (drawingManagerRef.current)
                                                    drawingManagerRef.current.setDrawingMode(
                                                        window.google.maps.drawing.OverlayType.CIRCLE
                                                    );
                                            }}
                                            className="flex-1 py-2 text-sm border rounded-lg hover:bg-white"
                                        >
                                            ⭕ Draw Circle Area
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (markerRef.current) {
                                                    markerRef.current.setMap(null);
                                                    markerRef.current = null;
                                                }
                                                if (currentPolygonRef.current) {
                                                    currentPolygonRef.current.setMap(null);
                                                    currentPolygonRef.current = null;
                                                }
                                                setMapCoords({ lat: null, lng: null });
                                                setPolygonCoords([]);
                                                setFormData(prev => ({ ...prev, radius: '' }));
                                            }}
                                            className="px-4 py-2 text-sm border rounded-lg hover:bg-red-50 text-red-500"
                                        >
                                            🗑 Clear
                                        </button>
                                    </div>

                                    <div className="bg-white rounded-lg p-3 font-mono text-xs text-gray-600 min-h-[40px] break-words">
                                        {polygonCoords.length > 0
                                            ? `🔷 Polygon: ${polygonCoords.map(c => `(${parseFloat(c.lat).toFixed(4)}, ${parseFloat(c.lng).toFixed(4)})`).join(" , ")}` + (mapCoords.lat ? ` | 📍 Marker: { lat: ${parseFloat(mapCoords.lat).toFixed(6)}, lng: ${parseFloat(mapCoords.lng).toFixed(6)} }` : '')
                                            : mapCoords.lat && !isNaN(parseFloat(mapCoords.lat))
                                                ? `📍 Marker: { lat: ${parseFloat(mapCoords.lat).toFixed(6)}, lng: ${parseFloat(mapCoords.lng).toFixed(6)} }` + (formData.radius ? ` ⭕ Radius: ${formData.radius}m` : '')
                                                : 'Click on map to place marker, or draw a polygon/circle area'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {!showForm && (
                <div className="mt-3">
                    <Table
                        handleEdit={handleEditData}
                        handleDelete={handleDelete}
                        loading={isLoading}
                        PageName={'PickupPointMaster'}
                        handleFilter={() => {
                            getPickupPointMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={tableData}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                        showActiveInactive={true}
                    />
                </div>
            )}
        </>
    )
}
export default PickupPointMaster;